/**
 * Site header
 */

let openMenuButton = $('.js-site-header-menu-button');
let closeMenuButton = $('.js-site-header-close-menu-button');
let overlay = $('.js-overlay');
let navWrapper = $('.js-site-header-nav-wrapper');
let linkDropdown = $('.js-menu-link-dropdown');

function openMenu() {
    openMenuButton.attr('aria-expanded', 'true');
    closeMenuButton.attr('aria-expanded', 'true');
    navWrapper.addClass('is-active');
    overlay.addClass('is-active');
    trapFocus(navWrapper);
}

function closeMenu() {
    openMenuButton.attr('aria-expanded', 'false');
    closeMenuButton.attr('aria-expanded', 'false');
    navWrapper.removeClass('is-active');
    overlay.removeClass('is-active');
    unTrapFocus(openMenuButton);
}
function toggleSublist(e) {
    e.preventDefault();
    if (!$(this).hasClass('is-active')) {
        linkDropdown.removeClass('is-active');
        linkDropdown.attr('aria-expanded', 'false');
        $('.js-site-header-nav-sublist').slideUp();
        $(this).addClass('is-active').next('.js-site-header-nav-sublist').stop(true, true).slideDown();
        $(this).attr('aria-expanded', 'true');
    } else {
        $(this).removeClass('is-active').next('.js-site-header-nav-sublist').stop(true, true).slideUp();
        $(this).attr('aria-expanded', 'false');
    }
}

function closeAllSublits() {
    linkDropdown.removeClass('is-active');
    linkDropdown.attr('aria-expanded', 'false');
    $('.js-site-header-nav-sublist').stop(true, true).slideUp()
}

openMenuButton.on('click', openMenu);

closeMenuButton.on('click', closeMenu);

linkDropdown.on('click', toggleSublist);

$(document).on('keydown', function (e) {
    if (e.key == 'Escape') {
        if (navWrapper.hasClass('is-active')) {
            closeMenu();
        } else if (linkDropdown.hasClass('is-active')) {
            closeAllSublits();
        }
    }
});

$(document).on('click', function (e) {
    let $target = $(e.target);
    if (!$target.closest('.c-site-header__nav-and-controls').length && navWrapper.hasClass('is-active')) {
        closeMenu();
    } else if (!$target.closest('.c-site-header-nav__list').length && linkDropdown.hasClass('is-active')) {
        closeAllSublits();
    }
});